import React from 'react'
import { Helmet } from 'react-helmet'
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader'
import Sec1 from '../../../Componet/Security/Sec1He'
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm'

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer'

function SecurityHePage() {
    return (
        <div className="security-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - אבטחת מידע וסייבר</title>
                <meta
                    name="description"
                    content="אבטחת מידע וסייבר לעסקים שצריכים הגנה טובה יותר על מערכות, תשתיות ומידע רגיש, עם DevSecOps, בקרות ותהליכים מעשיים."
                />
                <meta
                    name="keywords"
                    content="אבטחת מידע, סייבר, DevSecOps, פיתוח מאובטח, הגנת מידע, אבטחת תשתיות, אבטחת ענן"
                />
                <meta property="og:title" content="EpicFinal - אבטחת מידע וסייבר" />
                <meta
                    property="og:description"
                    content="חיזוק הגנה על מערכות, תשתיות ומידע רגיש באמצעות DevSecOps, בקרות, סקרי סיכונים והקשחת תהליכים."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/security" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - אבטחת מידע וסייבר" />
                <meta
                    name="twitter:description"
                    content="אבטחת מידע לעסקים שצריכים הגנה אמיתית, לא רק שכבת אבטחה על הנייר."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"אבטחת מידע וסייבר"} />
            <div className="page-content">
                <Sec1 />
                <ConsultingForm
                    language="he"
                    formId="epic-security-form"
                    conversionSendTo="AW-11461100984/oFXfCOLqtJgcELiLitkq"
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="ספרו לנו איפה צריך לחזק את האבטחה"
                    subtitle="השאירו פרטים קצרים ונחזור אליכם עם מענה מקצועי והכוונה ראשונית למצב האבטחה שלכם."
                />
                <NewsletterL1 />
            </div>
        </div>
    )
}

export default SecurityHePage

